import { httpClient, postProcessUpsert } from '@genai/http-client';
import { OrganizationId } from "../model";
import { UserId } from '../../user';

export function joinOrganization(
  organizationId: OrganizationId,
  userUuid: UserId,
  role: string,
  is_active: boolean
) {
  return httpClient(`/users/${userUuid}`, {
    method: "PUT",
    body: JSON.stringify({
      is_active: is_active? is_active : true,
      role: role ? role : "user",
      organization: organizationId
    }),
    headers: {
      "Content-Type": "application/json",
    },
  }).then(postProcessUpsert);
}
